<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <span  class="avatar-container-select">
      <el-select v-model="tenant"
         @change="selectTenant"
         placeholder="请选择租户"
         clearable style="width: 150px;"
         v-show="userGroup.length > 0">
        <el-option
          v-for="item in userGroup"
          :key="item.tenant"
          :label="item.tenantName"
          :value="item.tenant">
        </el-option>
      </el-select>
    </span>

    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <span>你好：{{getName()}}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <router-link class="inlineBlock" to="/ums/pwd">
        <el-dropdown-item>
          修改密码
        </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import {getCookie} from '@/utils/support';
import store from "../../../store";
import { setTenant, removeTenant } from '@/utils/auth'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data() {
    return {
      userGroup: [],
      tenant: null
    }
  },
  created() {
    removeTenant();
    if(store.getters.userGroup !== null && store.getters.userGroup !== undefined && store.getters.userGroup.length > 0) {
      this.userGroup = store.getters.userGroup;
      this.tenant = this.userGroup[0].tenant;
    }
    if (store.getters.tenant) {
      setTenant(store.getters.tenant);
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    getName() {
      return getCookie("username")
    },
    selectTenant(value) {
      if (value) {
        setTenant(value);
        this.$router.push({path: '/login'})
      }
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container-select {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 200px;
    top: 2px;
    font-size: 12px;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue